import { Flex, Form, Skeleton } from 'antd';
import React, { useState } from 'react';

import FieldColor from '../../components/fieldColor';
import WrapperTwoColumn from '../../components/WrapperTwoColumn';
import useAccessForItem from '../../hooks/useAccessForItem';
import useEffectBuffer from '../../hooks/useEffectBuffer';
import useObserverComponent from '../../hooks/useObserverComponent';
import useStatusEditProject from '../../hooks/useStatusEditProject';
import FieldCompletionPercentage from '../formField/fieldCompletionPercentage';
import FieldDescription from '../formField/fieldDescription';
import FieldEndDate from '../formField/fieldEndDate';
import FieldPriority from '../formField/fieldPriority';
import FieldStartDate from '../formField/fieldStartDate';
import FieldStatus from '../formField/fieldStatus';
import FieldType from '../formField/fieldType';
import TabsItems from '../formField/tabsItems';
import TabsResource from '../formField/tabsResource';
import useControlBondRight from '../formField/useControlBondRight';
import useControlChildren from '../formField/useControlChildren';
import useControlOtherFields from '../formField/useControlOtherFields';
import useControlParent from '../formField/useControlParent';
import useControlPercentage from '../formField/useControlPercentage';
import { GantItemFormProps } from './gantItemFormProps';

const GantItemForm: React.FC<GantItemFormProps> = ({
    form,
    currentItem,
    values,
    bufferItems,
    saveBufferToStore,
    moveItems,
    historyDeletedBondRight,
    historyDeletedChildren,
}) => {
    const isEditableProject = useStatusEditProject(currentItem?.projectId);
    const access = useAccessForItem(currentItem || null, [
        'work-item.all.edit',
        'work-item.all.manage',
        'work-item.owner.edit',
        'work-item.owner.manage',
        'work-item.assignee.edit',
        'work-item.assignee.manage',
    ]);

    const isHasChildren = Boolean(currentItem?.children?.length);
    const isHasChildrenOrEditable = isHasChildren || !isEditableProject;

    const { isVisible, ref } = useObserverComponent();

    const [isVisibleTabs, setIsVisibleTabs] = useState(false);

    useControlOtherFields(form, values, bufferItems, saveBufferToStore, currentItem!);
    useControlBondRight(values, bufferItems, saveBufferToStore, moveItems, historyDeletedBondRight, currentItem!);
    useControlChildren(values, bufferItems, saveBufferToStore, moveItems, historyDeletedChildren, currentItem!);
    useControlParent(values, bufferItems, saveBufferToStore, moveItems, historyDeletedChildren, currentItem!);
    useControlPercentage(values, bufferItems, saveBufferToStore, currentItem!);

    useEffectBuffer(
        () => {
            setIsVisibleTabs(isVisible);
        },
        200,
        [isVisible],
    );

    return (
        <>
            <Form name="scheduleItemFrom" layout="vertical" form={form} autoComplete="off">
                <WrapperTwoColumn
                    childFirstColumn={
                        <>
                            <FieldType disabled={!isEditableProject || !access} />
                            <FieldStartDate required disabled={!isEditableProject || !access} />
                            <FieldStatus disabled={true} />
                        </>
                    }
                    childSecondColumn={
                        <>
                            <FieldPriority disabled={!isEditableProject || !access} />
                            <FieldEndDate required disabled={!isEditableProject || !access} />
                            <Flex justify={'space-between'} gap={20}>
                                <div style={{ width: '100%' }}>
                                    <FieldCompletionPercentage
                                        disabled={
                                            !!(currentItem?.children?.length || currentItem?.tasks.length) ||
                                            !isEditableProject ||
                                            !access
                                        }
                                    />
                                </div>
                                <FieldColor disabled={!isEditableProject || !access} />
                            </Flex>
                        </>
                    }
                    style={{}}
                />
                <FieldDescription disabled={!isEditableProject || !access} />
            </Form>
            <div ref={ref}>
                {isVisibleTabs ? (
                    <TabsItems
                        form={form}
                        updatedItemId={currentItem?.id}
                        isEditable={isEditableProject && access}
                        projectId={currentItem?.projectId}
                        isMainItem={currentItem?.roleItem === 'project'}
                    />
                ) : (
                    <Skeleton active />
                )}
            </div>
            <TabsResource form={form} isEditableProject={isEditableProject && access} isHasChildren={isHasChildren} />
        </>
    );
};

export default GantItemForm;
